<div class="flex-row">
    <label for="zoom" class="number-input-label">Zoom</label>
    <input
        class="number-input-no-arrow"
        id="zoom"
        #zoomInputRef
        type="number"
        min="0"
        step="0.1"
        (blur)="setZoom(zoomInputRef.value)"
        [value]="zoomText"
    />
    <cds-button size="sm" action="flat" (click)="resetZoom()">1:1</cds-button>
    <cds-button size="sm" action="flat" (click)="viewer.toggleLayout()">{{
        viewer.getLayout()
    }}</cds-button>
</div>
